module.exports = __webpack_public_path__ + "img/circle_alert_one.45317a05.svg";